import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Panel,
  Row,
  Col,
  Button
 } from 'react-bootstrap';

class JNApiKeyInstructions extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleKeyDown(e) {
    if(e.key == 'Enter') {
      this.props.onHide();
    }
  }

  componentDidUpdate(prev_props) {
    if(!prev_props.show && this.props.show) {
      $(document).on('keydown', this.handleKeyDown);
    }
    else if(prev_props.show && !this.props.show) {
      $(document).off('keydown', this.handleKeyDown);
    }
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        >
        <Modal.Header>
          <Modal.Title>Job Nimbus API Key Instructions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel>
            <h4>Step 1 :</h4>
            <p>Log in to your <a href='http://www.jobnimbus.com/' target='_blank'>Job Nimbus account</a></p>
          </Panel>
          <Panel>
            <h4>Step 2 :</h4>
            <Row>
              <Col md={5} xs={12}>
                <p>
                  From the Dashboard, choose 'Settings' from the
                  top-right dropdown menu that contains your account name
                </p>
              </Col>
              <Col md={7} xs={12}>
                <img src='assets/images/jn-integration-step-2.png' style={{ float : 'right' }} />
              </Col>
            </Row>
          </Panel>
          <Panel>
            <h4>Step 3 :</h4>
            <Row>
              <Col md={4} xs={6}>
                <img src='assets/images/jn-integration-step-3.png' style={{ float : 'left' }} />
              </Col>
              <Col md={8} xs={6}>
                <p>On the left-hand side of the Settings page, choose 'API' from the navigation column.</p>
              </Col>
            </Row>
          </Panel>
          <Panel>
            <h4>Step 4 :</h4>
            <Row>
              <Col md={12} xs={12}>
                <img src='assets/images/jn-integration-step-4.png' />
              </Col>
              <Col md={12} xs={12}>
                <p><i>If you have already created an API key Job Nimbus, go to Step 5.</i></p>
                <p>In the 'Description' field, give the new API key a name (the name can be anything).</p>
                <p>Under 'Access Profile' choose 'Admin'</p>
                <p>Click the 'Save' button</p>
              </Col>
            </Row>
          </Panel>
          <Panel>
            <h4>Step 5 :</h4>
            <Row>
              <Col md={12} xs={12}>
                <img src='assets/images/jn-integration-step-5.png' />
              </Col>
              <Col md={12} xs={12}>
                <p>Click the 'Copy' button to copy the new API key.</p>
                <p>
                  Once the key is copied, paste it into the Hail Trace form on the previous
                  page and continue initializing your Job Nimbus integration.
                </p>
              </Col>
            </Row>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            block
            bsSize='small'
            bsStyle='success'
            onClick={this.props.onHide}
            >
            Got It!
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default JNApiKeyInstructions;



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-api-key-instructions.js